// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1w4jA","left":"StickyBox_left__CMqzf","right":"StickyBox_right__2al3G"};